import { TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import classNames from 'classnames';
import TabItem from './tab-item';
import { TabBarItem, TabSize } from './types';
interface Props {
  size: TabSize;
  items: TabBarItem[];
  defaultIndex?: number;
  headClassName?: string;
  bodyClassName?: string;
  tabClassName?: string;
  isProductsHeader?: boolean;
  isPinkBox?: boolean;
  hasLeftPadding?: boolean;
}
const TabBar = ({
  size = TabSize.Medium,
  items,
  defaultIndex = 0,
  headClassName,
  bodyClassName,
  tabClassName,
  isProductsHeader,
  isPinkBox,
  hasLeftPadding
}: Props) => {
  return <TabGroup defaultIndex={defaultIndex} className={`${isPinkBox ? 'p-2 pb-0 pl-0' : ''}`} data-sentry-element="TabGroup" data-sentry-component="TabBar" data-sentry-source-file="tab-bar.tsx">
            <div className={classNames(hasLeftPadding ? 'pl-0' : '')}>
                {items.length > 1 && <TabList className={classNames('flex w-full items-center justify-between', headClassName, isProductsHeader ? 'gap-3' : 'gap-4')}>
                        {items.map(({
          header,
          disabled = false
        }, index) => <TabItem key={index} size={size} disabled={disabled} className={classNames(tabClassName)} isProductsHeader>
                                {header}
                            </TabItem>)}
                    </TabList>}
            </div>
            <TabPanels className={classNames('h-full', bodyClassName)} data-sentry-element="TabPanels" data-sentry-source-file="tab-bar.tsx">
                {items.map(({
        body
      }, index) => <TabPanel className='h-full' key={index}>
                        {body}
                    </TabPanel>)}
            </TabPanels>
        </TabGroup>;
};
export default TabBar;